import React, { useState, useEffect } from 'react';
import HeadSub from '../../../../components/comm/HeadSub';
import ToastPopup from '../../../../components/comm/ToastPopup';
import HospitalSelectListBox from '../../../../components/box/HospitalSelectListBox';
import style from './NonFaceFindPassword.module.css';
import URL, { DPMSG_APIKEY } from '../../../../constants/url';
import { useNavigate } from "react-router-dom";
import axiosApi from '../../../../api/daonAxios';
import CODE from '../../../../constants/code';

import { BottomSheet } from 'react-spring-bottom-sheet';
import 'react-spring-bottom-sheet/dist/style.css';
import {
    getIsDpAuthUserId,
    sendAftcrEmailAuthNumber,
    setDpResetPasswordUid,
    verifyingEmailAuthNumber
} from '../../../../assets/js/comm';


const NonFaceFindPassword = () => {

    const navigate = useNavigate();

    const AFTCR_FIND_ID = "AFTCR_FIND_ID";
    const onDismiss = () => setOpen(false);

    const [step, setStep] = useState(1);
    const [open, setOpen] = useState(false);
    const [hospital, setHospital] = useState('');
    const [email, setEmail] = useState('');
    const [verificationCode, setVerificationCode] = useState('');
    const [patientCode, setPatientCode] = useState('');
    const [timeLeft, setTimeLeft] = useState(300); // 3분 = 180초
    const [isTimeout, setIsTimeout] = useState(false);


    //아이디
    const [enterId, setEnterId] = useState('');
    const [idRules, setIdRules] = useState({characters: false, numbers: false});

     // 패스워드 체크
    const [pwView, setPwView] = useState(false);
    const [rePwView, setRePwView] = useState(false);
    const [password, setPassword] = useState('');
    const [rePassword, setRePassword] = useState('');
    const [pwRules, setPwRules] = useState({
        length: false,
        number: false,
        letter: false,
        special: false,
    });

    //상태추가
    const [idFocused, setIdFocused] = useState(false);
    const [pwFocused, setPwFocused] = useState(false);
    const [rePwFocused, setRePwFocused] = useState(false);

    const [overseasUser, setOverseasUser] = useState({});
    // 토스트메시지 관련 세트
    const [toast, setToast] = useState(false);
    const [toastMessage, setToastMessage] = useState('');

    //아이디 체크
    const handleIdChange = (e) => {

        const value = e.target.value;
        if( step > 1) { // 제대로 진행을하지 않으면 되돌아 감.
            if( sessionStorage.getItem(AFTCR_FIND_ID) !== value ) {
                setStep(1);
            }
        }
        setEnterId(value);

        const characters = value.length >= 6;
        const numbers = /\d/.test(value);

        setIdRules({ characters, numbers});
    };

    //비번 체크
    const handlePwView = () => {
        setPwView(!pwView);
    }
    const handleRePwView = () => {
        setRePwView(!rePwView);
    }

    const handlePasswordChange = (e) => {
        const value = e.target.value;
        setPassword(value);

        const length = value.length >= 9;
        const number = /\d/.test(value);
        const letter = /[a-zA-Z]/.test(value);
        const special = /[!@#$%^&*(),.?":{}|<>]/.test(value);

        setPwRules({ length, number, letter, special });
    };

    const handleRePasswordChange = (e) => {
        setRePassword(e.target.value);
    };

    //버튼 활성화 조건
    const isNextEnabled = () => {
        if (step === 1) {
            return idRules.characters && idRules.numbers && enterId.length <= 12;
        }
        if (step === 2) {
            const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            return emailPattern.test(email);
        }
        if (step === 3) {
            return verificationCode.length > 0 && !isTimeout;
        }
        if (step === 4) {
            return pwRules.length && pwRules.number && pwRules.letter && pwRules.special;
        }
        if (step === 5) {
            return password && rePassword && password === rePassword;
        }
        return false;
    };

    // 병원 선택
    const onHospitalSelect = (selectedHospital) => {
        setHospital(selectedHospital);
        setOpen(false);
    };

    // 인증시간
    useEffect(() => {
        if (step >= 3 && timeLeft > 0) {
            const timer = setInterval(() => {
                setTimeLeft((prev) => prev - 1);
            }, 1000);
            return () => clearInterval(timer);
        } else if (timeLeft === 0) {
            setIsTimeout(true);
        }
    }, [timeLeft, step]);

    const formatTime = (seconds) => {
        const min = String(Math.floor(seconds / 60)).padStart(2, '0');
        const sec = String(seconds % 60).padStart(2, '0');
        return `${min}:${sec}`;
    };

    //다음 버튼
    const handleNext = () => {

        if(step === 1) {
            // 아이디 존재여부 체크 필요..
            getIsDpAuthUserId(enterId)
                .then((res) => {
                    //console.log(" ========> handleOnConfirm getIsDpAuthUserId res : ", res);
                    if (res) {
                        sessionStorage.setItem(AFTCR_FIND_ID, enterId);
                        // 아이디가 존재하는 경우, 다음스텝 진행
                        setStep(2);
                    } else {
                        setToastMessage("There is no registration information for that ID.");
                        setToast(true);
                        return false;
                    }
                })
                .catch((err) => {
                    console.log(" ====> handleOnConfirm getIsDpAuthUserId error : ", err);
                    setToastMessage("A problem has occurred. Please contact the administrator.");
                    setToast(true);
                });
        }
        if(step === 2) { // 메일 발송 단계...
            console.log( " ==========> nonFace email : ", email );

            // 세밀한 이메일 형식 정규식 (대문자, 소문자, 숫자, -, _, . 모두 허용)
            const emailPattern = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/;

            if (!emailPattern.test(email)) { // isNextEnabled 단계를 거치지만.. 재입력을 할수 있으므로 체크..
                setToastMessage("Please check the email format.");
                setToast(true);
                return false;
            }
            if( email ) {
                searchOverseasUserInfo()
                    .then( (resp) => {
                        //console.log("============> searchOverseasUserId result : ", resp);
                        if( resp?.resultCode === CODE.RCV_SUCCESS ) {
                            const userInfo = resp.result.aftcrUser;
                            setOverseasUser(userInfo); // 활용소지가 있는 경우에만 사용할것!
                            const nonUserInfo = {
                                to: email
                            }
                            // 메일서버 부하를 고려하여.. 애프터케어 사용자아이디 + 이메일정보 조합 회원정보 확인을 우선으로 함.
                            sendAftcrEmailAuthNumber(nonUserInfo); // 전송되든 안되든 중요하지가 않음.
                            setToastMessage("A verification code has been \n sent to  your email.");
                            setToast(true);
                            setStep(3);
                        } else {
                            setToastMessage("No matching entered ID and Email information. \nPlease check again.");
                            setToast(true);
                        }
                    })
                    .catch((err) => {
                        console.log("==========> searchOverseasUserId Error : ", err);
                    })

            } else {
                setToastMessage("Your email address is missing or not verified.\n Please enter it correctly.");
                setToast(true);
                return false;
            }

        }
        if (step === 3) {

            //console.log( " ==========> nonFace email verificationCode : ", verificationCode );
            if( verificationCode ) {
                const nonUserInfo = {
                    to: email
                    , authNumber: verificationCode
                }
                verifyingEmailAuthNumber(nonUserInfo)
                    .then( async (res) => {
                        //console.log(" ========> Email Verification Code res : " , res);

                        if( res?.resultCode === CODE.RCV_SUCCESS ) {
                            // 해당 단계에서 스텝전환이 필요함에따라 인증관련하여 성공시에는 메시지 처리가 크게 중요하진 않아보임.
                            //setToastMessage("Email verification has been completed.");
                            //setToast(true);
                            setIsTimeout(true);
                            // 인증번호가 맞는 경우.. 회원조회 시도 로직 가동
                            setStep(4);
                        } else {
                            setToastMessage("The Email Address and verification code does not match. \nPlease try again.");
                            setToast(true);
                        }
                    })
                    .catch( (err) => {
                        console.log(" =======> Email Verification Code Error : ", err );
                    })
            } else {
                setToastMessage("The verification number was not entered.. \nPlease check again.");
                setToast(true);
                return false;
            }
        }
        if( step === 4 ) {
            setStep(5);
        }
        if (step === 5) {
            handlePw();
        }
    };

    //
    /**
     * 해외환자 사용자 아이디 조회 호출
     */
    const searchOverseasUserInfo = () => {

        const requestApiUrl = "/signup/retrieveUserSimple";

        const requestBody = {
            usrId: enterId
            , emailAdres: email
            , usrSeCd: "17" // 해외환자임으로 고정처리..
        };

        return axiosApi.post(requestApiUrl, requestBody)
            .then( (res) => res.data )
            .catch(err => {
                console.error( err );
                throw err;
            });
    };

    const handleOnBack = () => {
        navigate(URL.NONFACE_LOGIN_MAIN,
            {
                replace: true,
                state: { refreshAt: false }
            });
    };

    /**
     * 비밀번호 재설정
     */
    const handlePw = () => {

        if( password === rePassword ) {
            // dp 로직+
            const requestDpAuthStrUrl = "/signup/requestDpAuthString";

            axiosApi.get(requestDpAuthStrUrl)
                .then( async (res) => {

                    if(res.data.resultCode === CODE.RCV_SUCCESS) {
                        const authStr = res.data.result?.dpAuthStr;

                        await setDpResetPasswordUid(overseasUser?.usrUid, authStr, rePassword)
                            .then( async (res) => {

                                if(res.data === "success") {
                                    const requestChangePasswordUrl = "/signup/actionChangePassword"

                                    const requestParams = {
                                        usrUid: overseasUser?.usrUid
                                        , usrId: overseasUser?.usrId
                                        , usrPswd: rePassword
                                    }

                                    const requestOptions = {
                                        headers: {
                                            'authorization': DPMSG_APIKEY
                                        },
                                        noLoading: true
                                    }

                                    await axiosApi.post(requestChangePasswordUrl, requestParams, requestOptions)
                                        .then( (res) => {
                                            sessionStorage.setItem(AFTCR_FIND_ID, ""); // 이 단계에서는 지워져도 상관없음
                                            if(res.data.resultCode === CODE.RCV_SUCCESS) {
                                                // 비밀번호 변경 성공.. // 결과값은 따로 체크할 필욘 없을듯...
                                                setToastMessage('Password has been changed successfully.');
                                                setToast(true);
                                                // 토스트가 보이도록 2초 후 페이지 이동
                                                setTimeout(() => {
                                                    handleOnBack();
                                                }, 2000);
                                                //handleOnBack();
                                            } else {
                                                // 백엔드 서버가 문제있지 않는한.. 이쪽으로 떨어질 일이 없음
                                                setToastMessage('Password reset failed. Please try again.');
                                                setToast(true);
                                                return false;
                                            }
                                        })
                                        .catch( err => {
                                            console.log( " ================> setDpResetPasswordUid api error: ", err );
                                            sessionStorage.setItem(AFTCR_FIND_ID, "");
                                            setToastMessage('An error occurred while changing your password (L2). You will now be redirected to the login screen.');
                                            setToast(true);
                                            handleOnBack();
                                        })
                                }
                            })
                            .catch( err => {
                                console.log("=========> setDpResetPasswordUid func error : ", err);
                                sessionStorage.setItem(AFTCR_FIND_ID, "");
                                setToastMessage('An error occurred while changing your password (D). You will now be redirected to the login screen.');
                                setToast(true);
                                handleOnBack();
                            })
                    }
                })
                .catch(err => {
                    console.log("=========> requestDpAuthString api error : ", err);
                    sessionStorage.setItem(AFTCR_FIND_ID, "");
                    setToastMessage('An error occurred while changing your password (L1). You will now be redirected to the login screen.');
                    setToast(true);
                    handleOnBack();
                })
        } else {
            setToastMessage('Passwords do not match.\n' +
            'Please try again.');
            setToast(true);
        }
    };


    return (
        <>
            <HeadSub
                title="Find Password"
                onBack={() => {
                    if (step === 4 || step === 5) {
                    setStep(3);
                    }
                    else {
                    navigate(-1);
                    }
                }}
            />

                <div id="sub-content" data-layout="white">
                    <div className='inner-wrap' data-padding="30">


                        <div className={style['content-box']}>
                            <strong className={style['title']}>
                                {step === 2 ? 'Please enter your email'
                                    : step === 3 ? ' Please enter verification code '
                                    : step >= 4 ? ' Please set your new password '
                                    : 'Please enter your ID'
                                }
                            </strong>


                        {step >= 7 && (
                            <div className={style['input-wrap']}>
                                <div className='animation-2'>
                                <span className={style['input-tit']}>Patient number</span>
                                <div className={style['input-box']}>
                                    <input
                                        type="number"
                                        placeholder="00000000"
                                        onChange={(e) => setPatientCode(e.target.value)}
                                        onKeyUp={(e) => {
                                            if (e.key === 'Enter' && isNextEnabled()) {
                                            handleNext();
                                            }
                                        }}
                                    />
                                    <span className={style['line']}></span>
                                </div>
                                </div>
                            </div>
                        )}


                        {step >= 6 && (
                            <div className={style['input-wrap']}>
                                <div className='animation-2'>
                                <span className={style['input-tit']}>Hospital</span>
                                <div className={style['input-box']} data-type-input="btn">
                                    <input
                                        type="text"
                                        placeholder={hospital || "Select a hospital"}
                                        className={style['hospital-input']}
                                        onClick={() => setOpen(true)}
                                        value={hospital}
                                        onKeyUp={(e) => {
                                                if (e.key === 'Enter' && isNextEnabled()) {
                                                handleNext();
                                                }
                                            }}
                                        readOnly

                                    />
                                    <span className={style['line']}></span>
                                </div>
                                </div>
                            </div>
                        )}



                        {step >= 5 && (
                            <div className={style['input-wrap']}>
                                <div className='animation-2'>
                                    <span className={style['input-tit']}>Confirm Password</span>
                                    <div className={ style['input-box']}>
                                        <div className={style['pw-box']}>
                                            <input
                                                type={rePwView ? "text" : "password"}
                                                placeholder="Enter your desired Password "
                                                value={rePassword}
                                                onChange={handleRePasswordChange}
                                                onFocus={() => setRePwFocused(true)}
                                                onBlur={() => setRePwFocused(false)}
                                                onKeyUp={(e) => {
                                                    if (e.key === 'Enter' && isNextEnabled()) {
                                                    handleNext();
                                                    }
                                                }}
                                            />
                                            <span className={style['line']}></span>
                                        </div>
                                        <button className={style['pw-view-btn']} data-view={rePwView ? "on" : "off"} onClick={handleRePwView}>
                                            <span className='blind'>패스워드 on/off</span>
                                        </button>
                                    </div>

                                    {(rePwFocused) && (
                                        <div className={style['input-bottom-box']}>
                                            {password && rePassword && password === rePassword ? (
                                                <span className={style['on']}>Passwords match</span>
                                            ) : (
                                                <span className={style['error']}>Passwords do not match</span>
                                            )}
                                        </div>
                                    )}

                                </div>
                            </div>
                        )}

                        {step >= 4 && (
                            <div className={style['input-wrap']}>
                                <div className='animation-2'>
                                    <span className={style['input-tit']}>Password</span>
                                    <div className={style['input-box']}>
                                        <div className={style['pw-box']}>
                                            <input
                                                type={pwView ? "text" : "password"}
                                                placeholder="Enter your desired Password"
                                                value={password}
                                                onChange={handlePasswordChange}
                                                onFocus={() => setPwFocused(true)}
                                                onBlur={() => setPwFocused(false)}
                                                onKeyUp={(e) => {
                                                    if (e.key === 'Enter' && isNextEnabled()) {
                                                    handleNext();
                                                    }
                                                }}
                                            />
                                            <span className={style['line']}></span>
                                        </div>
                                        <button className={style['pw-view-btn']} data-view={pwView ? "on" : "off"} onClick={handlePwView}>
                                            <span className='blind'>패스워드 on/off</span>
                                        </button>
                                    </div>
                                    {(pwFocused) && (
                                        <div className={style['input-bottom-box']}>
                                            <span className={pwRules.length ? style['on'] : ''}>At least 9 characters</span>
                                            <span className={pwRules.letter ? style['on'] : ''}>Letter</span>
                                            <span className={pwRules.number ? style['on'] : ''}>Number</span>
                                            <span className={pwRules.special ? style['on'] : ''}>Special character</span>
                                        </div>
                                    )}
                                </div>
                            </div>
                        )}

                        { step >= 3 && step < 4 &&  (

                            <div className={style['input-wrap']}>
                                <div className='animation-2'>
                                <span className={style['input-tit']}>Verification code</span>
                                <div className={style['input-box']}>
                                    <input
                                        type="number"
                                        placeholder="Enter verification code"
                                        value={verificationCode}
                                        onChange={(e) => setVerificationCode(e.target.value)}
                                        onKeyUp={(e) => {
                                            if (e.key === 'Enter' && isNextEnabled()) {
                                            handleNext();
                                            }
                                        }}
                                    />
                                    <span className={style['line']}></span>
                                    <button className={style['cancel-btn']} onClick={() => setVerificationCode('')}></button>
                                </div>
                                <div className={style['input-bottom']}>
                                    <span className={style['time']}>
                                        {isTimeout ? 'Authentication timeout' : formatTime(timeLeft)}
                                    </span>
                                    <button
                                        className={style['request-btn']}
                                        disabled={!(isTimeout || timeLeft < 240) }
                                        onClick={() => {
                                            setTimeLeft(300); // 타이머 초기화
                                            setIsTimeout(false);
                                            setVerificationCode('');
                                            const nonUserInfo = {
                                                to: email
                                            }
                                            sendAftcrEmailAuthNumber(nonUserInfo); // 전송되든 안되든 중요하지가 않음.
                                            setToastMessage("A verification code has been \n sent to  your email.");
                                            setToast(true);
                                        }}
                                    >
                                        <span>Resend</span>
                                    </button>
                                </div>
                                </div>
                            </div>
                        )}

                        {step >= 2 && step < 4 && (

                            <div className={style['input-wrap']}>
                                <div className='animation-2'>
                                <span className={style['input-tit']}>Email</span>
                                <div className={style['input-box']}>
                                    <input
                                        type="email"
                                        placeholder="aaaaa@email.com"
                                        value={email}
                                        onChange={(e) => setEmail(e.target.value)}
                                        onKeyUp={(e) => {
                                            if (e.key === 'Enter' && isNextEnabled()) {
                                            handleNext();
                                            }
                                        }}
                                    />
                                    <span className={style['line']}></span>
                                </div>
                                </div>
                            </div>

                        )}

                        {step >= 1 && step < 4 && (

                                <div className={style['input-wrap']}>
                                    <div className='animation-2'>
                                        <span className={style['input-tit']}>ID</span>
                                        <div className={style['input-box']}>
                                            <input
                                                type="text"
                                                placeholder="Enter ID"
                                                value={enterId}
                                                onChange={handleIdChange}
                                                onKeyUp={(e) => {
                                                    if (e.key === 'Enter' && isNextEnabled()) {
                                                    handleNext();
                                                    }
                                                }}
                                            />
                                            <span className={style['line']}></span>
                                        </div>

                                    </div>
                                </div>
                        )}

                        </div>
                        {/* 아이디 비밀번호 입력 화면:: E */}



                        {/* 다음 버튼 */}
                    <div className="bottom-fixed-box">
                        <div className="inner-box">
                            <div className="btn-layout" data-btn-num="1">
                                <button
                                    className="btn"
                                    data-btn-type="fill-main"
                                    data-btn-size="lg"
                                    onClick={handleNext}
                                    disabled={!isNextEnabled()}
                                >
                                    <span>
                                        {step === 3 || step === 5 ? 'Confirm'
                                        :  'Next'
                                        }
                                    </span>
                                </button>
                            </div>
                        </div>
                    </div>

                    {/* 토스트 */}
                    {toast && (
                        <ToastPopup
                            setToast={setToast}
                            message={toastMessage}
                            position="center"
                            opacity="90"
                        />
                    )}

                    {/* 병원 바텀시트 */}
                    <BottomSheet
                        scrollLocking={false} // 내부 스크롤을 위해 BottomSheet 스크롤 잠금 해제
                         expandOnContentDrag={false} // 내용 드래그로 확장 방지
                        open={open}
                        onDismiss={onDismiss}
                        snapPoints={({ minHeight }) => minHeight}
                        blocking={true}
                    >
                        <HospitalSelectListBox
                            onClose={onDismiss}
                            onSelect={onHospitalSelect}
                        />
                    </BottomSheet>


                    </div>
                </div>
        </>
    )
}

export default NonFaceFindPassword
